// Phase 32 Plan 32-03 (RUNE-34) — Cascade frontier atom.
//
// Single nanostore atom carrying the count of new cells that have begun
// `spawning-in` during the active reveal cinematic. Default 0 — reset to 0
// on reveal unmount.
//
// Producers: `useRevealFSM` (writes 0..12 in 12 setTimeout fires @ 100ms
// stagger during the `cell-cascade` phase). FlopReveal + RiverReveal mirror
// `fsm.cascadeFrontier` into this atom via a useEffect.
//
// Consumers (Plan 32-05): `LetterCubeSprite` reads via `useStore` and
// self-fires `setState('spawning-in')` when its `cell_idx` falls inside the
// active frontier window. Pitfall 3 mitigation: the per-cell sprite owns
// its own state, removing the race between FlopReveal's
// `letterCubeSprites[idx].setState(...)` call and LetterLayer's mount of
// the new sprite for that idx.
//
// Atom semantics:
//   - 0 = no cascade active (reveal not mounted, or reveal mounted but
//         cascade phase not yet started; OR reduced motion active —
//         frontier stays 0 forever).
//   - N ∈ [1..12] = first N cells of the active growth wave should be
//         in `spawning-in` state.
//   - 12 = all cells in the active wave have begun (cascade phase end).
//   - Atom is RESET to 0 in the reveal component's useEffect cleanup so
//     a future reveal starts from a clean slate.

import { atom } from 'nanostores'

/** Count [0..12] of new cells currently in `spawning-in` during a reveal. */
export const $cascadeFrontier = atom<number>(0)
